<template>
  <div class="mark-detail-deal-wrap">
    <Breadcrumb :options="crumbOptions"></Breadcrumb>
    <div class="card-wrap teamDetail">
      <div class="result-wrap">
        <MediaWrap
          class="audio-wrap"
          :url="url"
          :width="250"
          :height="230"
        ></MediaWrap>
        <div class="right-wrap">
          <div class="head-wrap">
            <div class="techTitle">
              {{ detailObj.name }}
            </div>
          </div>
          <span class="line"></span>
          <div class="mark-card-body-wrap">
            <div>地址：{{ detailObj.address }}</div>
            <div>联系人：{{ detailObj.contact }}</div>
            <div>联系方式：{{ detailObj.mobile }}</div>
          </div>
        </div>
      </div>
      <TitleCard title="简介" :showMore="false">
        <div class="detailContent" v-html="detailObj.brief"></div>
      </TitleCard>
      <TitleCard title="研究内容" :showMore="false">
        <div class="detailContent" v-html="detailObj.content"></div>
      </TitleCard>
      <TitleCard title="科研成果" :showMore="false">
        <a-table
          :columns="fields"
          :data-source="detailObj.techPatents"
          :pagination="false"
          bordered
        >
        </a-table>
      </TitleCard>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { getCurrentCrumb } from '@/utils/crumb.js'
import { queryTeamInfos } from '@/api/talentsInfo.js'
export default {
  data() {
    return {
      result: {},
      baseInfos: {},
      fields: [
        {
          title: '序号',
          dataIndex: 'serialNo',
          width: '80px'
        },
        {
          title: '申请号',
          dataIndex: 'applicationNo'
        },
        {
          title: '专利名称',
          dataIndex: 'name'
        },
        {
          title: '申请人',
          dataIndex: 'applicant'
        },
        {
          title: '发明人',
          dataIndex: 'inventor'
        },
        {
          title: '公开（公告）号',
          dataIndex: 'publicationNo'
        },
        {
          title: '法律状态',
          dataIndex: 'legalStatus'
        }
      ],
      patentData: [],
      crumbOptions: [],
      detailObj: {},
      url: ''
    }
  },
  components: {
    // DetailPageWrap,
    Breadcrumb
  },
  created() {
    this.init()
    this.initSetting()
  },
  methods: {
    async init() {
      let id = this.$route.query.id
      const { data } = await queryTeamInfos(id)
      data.techPatents.forEach((item, index) => {
        item.key = index
      })
      this.detailObj = data
      this.url = this.getUrl(this.detailObj)
    },
    initSetting() {
      Object.assign(this, this.titleCardOptions)
      this.settingCrumb()
    },
    settingCrumb() {
      const { path } = this.$route

      const crumbOptions = getCurrentCrumb(path)

      this.crumbOptions = crumbOptions
    },
    getUrl(item) {
      if (item.fileVo !== null && item.fileVo.length > 0) {
        return item.fileVo[0].filePath
      } else {
        return ''
      }
    }
  }
}
</script>
